module.exports = __webpack_public_path__ + "media/images/pages/team-1-f892c94a6853fc83071b20a9be4e4e8b.jpg";